import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getMarketsOverview, getYieldCurve } from '../markets.routes';
import type { MarketsOverviewPageModel, YieldCurvePageModel } from '../types';

export const marketsOverviewQueryKey = (selectedDate?: string | null) =>
  ['markets-overview', selectedDate] as const;

export const useMarketsOverviewQuery = (
  selectedDate?: string | null,
  options?: Omit<
    UseQueryOptions<MarketsOverviewPageModel, Error>,
    'queryKey' | 'queryFn' | 'enabled'
  >,
) => {
  return useQuery<MarketsOverviewPageModel, Error>({
    queryKey: marketsOverviewQueryKey(selectedDate),
    queryFn: () => getMarketsOverview(selectedDate!),
    enabled: !!selectedDate,
    staleTime: 5 * 60 * 1000,
    ...options,
  });
};

export const useYieldCurveQuery = (
  currency?: string | null,
  curve?: string | null,
  positionDate?: string | null,
  options?: Omit<
    UseQueryOptions<YieldCurvePageModel, Error>,
    'queryKey' | 'queryFn' | 'enabled'
  >,
) => {
  return useQuery<YieldCurvePageModel, Error>({
    queryKey: ['yield-curve', currency, curve, positionDate],
    queryFn: () =>
      getYieldCurve({
        currency: currency!,
        curve: curve!,
        positionDate: positionDate!,
      }),
    enabled: !!currency && !!curve && !!positionDate,
    staleTime: 5 * 60 * 1000,
    ...options,
  });
};
